import { put } from 'redux-saga/effects'
import { IPcr } from '../../../../pcr/store/pcr.types'
import { setDrainsAndTubes } from '../store/drainsAndTubes.actions'

export function* getDrainsAndTubes(pcrDoc: IPcr) {
  const drainsAndTubes = pcrDoc.additionalAssessment?.drainsAndTubes

  if (drainsAndTubes && Object.keys(drainsAndTubes).length !== 0) {
    yield put(setDrainsAndTubes(drainsAndTubes))
  }
}
